import type { FunctionComponent } from "react"
import type { ReactPlayerProps } from "react-player"

import ReactPlayer from "react-player"

import { FixedAspectRatioContainer } from "./FixedAspectRatioContainer"

export type VideoPlayerProps = ReactPlayerProps & {
  className?: string
  url: string
}

export const VideoPlayer: FunctionComponent<VideoPlayerProps> = ({ className, url, ...playerProps }) => (
  <FixedAspectRatioContainer className={className}>
    <ReactPlayer controls height="100%" url={url} width="100%" {...playerProps} />
  </FixedAspectRatioContainer>
)
